(function () {
  var pricePattern = /\b\d+(?:\.\d+)?\s?JD\b/gi;

  function updateJDPrices(root) {
    root = root || document.body;
    var walker = document.createTreeWalker(
      root,
      NodeFilter.SHOW_TEXT,
      null,
      false
    );
    var node;
    while ((node = walker.nextNode())) {
      var text = node.nodeValue;
      if (!pricePattern.test(text)) continue;
      var newText = text
        .replace(/(\.\d*?[1-9])0+\s?JD/gi, "$1 JD")
        .replace(/\.0+\s?JD/gi, " JD");
      if (newText !== text) node.nodeValue = newText;
    }
  }

  if (document.body) updateJDPrices();

  document.addEventListener("DOMContentLoaded", function () {
    updateJDPrices();
  });

  var mo = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (n) {
        if (n.nodeType === 1) updateJDPrices(n); // process new subtree
      });
    });
  });
  mo.observe(document.body, { childList: true, subtree: true });
})();
